var module = angular.module('octopusApp.shared');

module.directive('emailAddressesInput', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      model: '='
    },
    template: '<input type="text" class="form-control" ng-model="model" placeholder="Separate multiple email addresses with semicolons or commas" />'
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/email_addresses_input.js
// module id = 3078501238241613
// module chunks = 1